<footer>
  <div class="footer-container">
    <div class="footer-brand">
      <div class="footer-logo">
        <img src="/images/landing/logo.svg" alt="Wealthlane" class="logo-img">
        <h3>ealthlane</h3>
      </div>
      <p>La plateforme de conseil patrimonial intelligente dédiée aux experts-comptables. Transformez vos données comptables en stratégies patrimoniales personnalisées.</p>
      <p class="footer-highlight">
        Rejoignez les experts-comptables qui développent déjà leur activité patrimoniale avec Wealthlane.
      </p>
      <div class="footer-socials">
        <a  rel="noopener noreferrer">
          <img src="/images/landing/linkedIn.svg" alt="LinkedIn" />
        </a>
        <a  rel="noopener noreferrer">
          <img src="/images/landing/tiktok.svg" alt="TikTok" />
        </a>
        <a  rel="noopener noreferrer">
          <img src="/images/landing/instagram.svg" alt="Instagram" />
        </a>
        <a  rel="noopener noreferrer">
          <img src="/images/landing/youtube.svg" alt="Youtube" />
        </a>
      </div>
    </div>
    <div class="footer-links">
      <h4>Navigation</h4>
      <ul>
        <li><a  (click)="scrollTo('constat')">Constat</a></li>
        <li><a  (click)="scrollTo('solution')">Solution</a></li>
        <li><a  (click)="scrollTo('processus')">Processus</a></li>
        <li><a  (click)="scrollTo('tarifs')">Tarifs</a></li>
        <li><a  (click)="scrollTo('roi')">Revenus</a></li>
      </ul>
    </div>
    <div class="footer-links">
      <h4>Entreprise</h4>
      <ul>
        <li><a >Mentions légales</a></li>
        <li><a >CGU</a></li>
        <li><a >Politique de confidentialité</a></li>
        <li><a >Cookies</a></li>
        <li><a >Contact</a></li>
      </ul>
    </div>
  </div>
  <div class="footer-bottom">
    <p>💎 Wealthlane - Conseil patrimonial intelligent pour experts-comptables</p>
    <p class="footer-bottom-note">© 2024 Wealthlane. Tous droits réservés.</p>
  </div>
</footer>

